import { render } from "./scanqrcode.vue?vue&type=template&id=5d8b204b"
import script from "./scanqrcode.vue?vue&type=script&lang=js"
export * from "./scanqrcode.vue?vue&type=script&lang=js"

import "./scanqrcode.vue?vue&type=style&index=0&id=5d8b204b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__